// extracted by mini-css-extract-plugin
export default {"wrapper":"Tz","subscription":"Uz","select_item":"Vz","is_selected":"Wz","otb":"Xz","radio":"Yz","first_row":"Zz","prices":"aA","italic":"bA","info_wrapper":"cA","first_month":"eA","separator":"fA","checkmark":"gA","bullets":"hA","bullet":"iA","checkmarkText":"jA","button":"kA","discountBadge":"lA"};
    if(module.hot) {
      // 1711717533331
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  